module.exports = __webpack_public_path__ + "7504f2730feaa9b040dd18e2b8dd77d4.svg";